module.exports = __webpack_public_path__ + "img/signal-app2.08d6f3a0.png";